import { useEffect, useRef } from 'react';
import { SMLAnalytics } from '../../analytics/sml/analytics';
import { CreationSource } from './types';

/** The pick of a source that holds music, or null for no music yet. */
function pickKeyOf(source: CreationSource): string | null {
  switch (source.kind) {
    case 'catalogTrack':
      return source.trackMaid;
    case 'catalogRow':
      return source.item.uuid;
    case 'url':
      return source.url;
    case 'none':
    case 'manual':
    case 'blank':
      return null;
  }
}

/**
 * `smartlink_create_started`, once per pick. The creation sheet replaced the old wizards, and only
 * the wizards sent it, so the web had no traffic. A catalog row is the music itself (an unreleased
 * row resolves to nothing); a track and a link wait for the answer of the resolver.
 */
export function useTrackCreateStarted(source: CreationSource, isResolved: boolean): void {
  const key = pickKeyOf(source);
  const isKnown = isResolved || source.kind === 'catalogRow';
  const media = source.kind === 'url' ? 'other' : 'track';
  const started = useRef<string | null>(null);
  useEffect(() => {
    if (!isKnown || key === null || started.current === key) {
      return;
    }
    started.current = key;
    SMLAnalytics.trackSmartLinkCreateStarted('release', media).catch(console.error);
  }, [isKnown, key, media]);
}
